type PolicyWindowCharge = {
  chargePercentage?: number | null
  chargeMinutes?: number | null
}

export function formatChargeHoursFromMinutes(chargeMinutes: number): string {
  const hours = chargeMinutes / 60
  return String(hours)
}

/** Admin display copy for a policy window charge, e.g. "50%" or "4 hours". */
export function formatPolicyWindowCharge(policy: PolicyWindowCharge): string {
  if (policy.chargeMinutes != null) {
    return `${formatChargeHoursFromMinutes(policy.chargeMinutes)} hours`
  }
  if (policy.chargePercentage != null) {
    return `${policy.chargePercentage}%`
  }
  return '—'
}

export function chargeHoursToMinutes(chargeHours: number): number {
  return Math.round(chargeHours * 60)
}
